export default __webpack_public_path__ + "static/media/rejected.dd28f67b.jpg";